import React from 'react';

import BreadcrumbItem, { BreadcrumbItemProps } from './BreadcrumbItem/BreadcrumbItem';
import './styles.scss';

export interface BreadcrumbsProps {
  items: BreadcrumbItemProps[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <div className="breadcrumb-container">
      {items.map((breadcrumb, idx, itemsArr) => (
        <BreadcrumbItem
          key={idx}
          label={breadcrumb.label}
          link={breadcrumb.link}
          activeRoute={idx === itemsArr.length - 1}
        />
      ))}
    </div>
  );
};

export default Breadcrumbs;
